export class CoachingPayment {
    constructor(coachingPayment) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userPaymentId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodStart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodEndDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deletedAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coachingStripePayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coachingAmazonPayPayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = coachingPayment.id;
        this.userPaymentId = coachingPayment.userPaymentId;
        this.curPeriodStart = coachingPayment.curPeriodStart;
        this.curPeriodEnd = coachingPayment.curPeriodEnd;
        this.curPeriodEndDate = new Date(coachingPayment.curPeriodEnd * 1000);
        this.paymentStatus = coachingPayment.paymentStatus;
        this.isValid = coachingPayment.isValid;
        this.deletedAt = coachingPayment.deletedAt;
        this.coachingStripePayment = coachingPayment.coachingStripePayment;
        this.coachingAmazonPayPayment = coachingPayment.coachingAmazonPayPayment;
    }
    get isOngoing() {
        return this.isValid && !this.deleted;
    }
    get deleted() {
        return this.deletedAt !== null;
    }
    get planName() {
        var _a, _b, _c, _d;
        return (_d = ((_b = (_a = this.coachingStripePayment) === null || _a === void 0 ? void 0 : _a.coachingStripePlan) !== null && _b !== void 0 ? _b : (_c = this.coachingAmazonPayPayment) === null || _c === void 0 ? void 0 : _c.coachingAmazonPayPlan)) === null || _d === void 0 ? void 0 : _d.name;
    }
    get planPrice() {
        var _a, _b, _c, _d;
        return (_d = ((_b = (_a = this.coachingStripePayment) === null || _a === void 0 ? void 0 : _a.coachingStripePlan) !== null && _b !== void 0 ? _b : (_c = this.coachingAmazonPayPayment) === null || _c === void 0 ? void 0 : _c.coachingAmazonPayPlan)) === null || _d === void 0 ? void 0 : _d.amount;
    }
}
